import { useMapPagePresenter } from '@Map/FloorMap/Components/MapPage/MapPagePresenter';
import { MapGrid } from '@Map/shared/MapGrid';
import { MapPointer } from '@Map/shared/MapPointer';
import { transformPoint } from '@Utils/3d';
import { calculateFitScaleFactor } from '@Utils/scale-utils';
import { utilStyles } from '@Utils/utilStyles';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { View } from 'react-native';

export const MiniMapLayoutContent = observer(function MiniMapLayoutContent() {
  const {
    gridColumnCount,
    gridRowCount,
    floorCameraPosition: cameraPosition,
    floorLayoutSize,
  } = useMapPagePresenter();

  const [wrapperWidth, setWrapperWidth] = useState(0);
  const [wrapperHeight, setWrapperHeight] = useState(0);

  if (!floorLayoutSize) {
    return null;
  }

  const cellSize = calculateFitScaleFactor({
    containerWidth: wrapperWidth,
    containerHeight: wrapperHeight,
    containedWidth: gridColumnCount,
    containedHeight: gridRowCount,
  });

  const [scaledWidth, scaledHeight] = [
    gridColumnCount * cellSize,
    gridRowCount * cellSize,
  ];

  const { x, y } = transformPoint(
    floorLayoutSize,
    {
      width: scaledWidth,
      height: scaledHeight,
    },
    cameraPosition && {
      x: cameraPosition.x,
      y: cameraPosition.y,
    }
  );

  return (
    <View
      style={[
        utilStyles.height100pc,
        utilStyles.width100pc,
        utilStyles.justifyContentCenter,
        utilStyles.alignItemsCenter,
      ]}
      onLayout={(event) => {
        setWrapperWidth(event.nativeEvent.layout.width);
        setWrapperHeight(event.nativeEvent.layout.height);
      }}
    >
      <View
        style={{
          width: scaledWidth,
          height: scaledHeight,
        }}
      >
        <MapGrid cellSize={cellSize} gapSize={2} borderRadius={10} />
        <MapPointer y={y} x={x} size={13} />
      </View>
    </View>
  );
});
